import { LoadLocation } from '../common/interfaces/loads/ILoadListData';
import { IOfferLoadLocation } from '../common/interfaces/offers/IOfferLoad';
import { IWonOfferLoadLocation } from '../common/interfaces/offers/IWonOfferResponse';

export const EMPTY_FIELD = '---';

export const isNotEmpty = (value: any): boolean => {
    return typeof value === 'string' && value.trim().length > 0;
};

export const isNullOrEmpty = (text: string | null | undefined): boolean => {
    return !isNotEmpty(text);
};

export const truncateString = (
    text: string,
    indexToTruncate: number,
): string => {
    return `${text.substring(0, indexToTruncate)}...`;
};

export const getStringValueOrNoInfoText = (
    text?: string,
    placeholder?: string,
): string => {
    if (text === undefined) return placeholder ?? EMPTY_FIELD;

    return text;
};

export const getCodeAndDescriptionFormatted = (
    code?: string,
    description?: string,
    placeholder?: string,
): string => {
    return `[${getStringValueOrNoInfoText(code, placeholder)}] ${getStringValueOrNoInfoText(description, placeholder)}`;
};

export const getAddressFormatted = (
    location:
        | IOfferLoadLocation
        | IWonOfferLoadLocation
        | LoadLocation
        | undefined,
): string => {
    return `${getCodeAndDescriptionFormatted(
        location?.code,
        location?.description,
    )} - ${location?.address} - ${location?.city} - ${location?.federativeUnit}`;
};

export const getLabelDescription = (description: string, code: string) => {
    const prefix = code ? `[${code}] ` : '';
    return `${prefix} ${description ?? ''}`;
};

export const getCityAndfederativeUnitDescriptionFormatted = (
    city?: string,
    federativeUnit?: string,
    placeholder?: string,
): string => {
    return `${getStringValueOrNoInfoText(city, placeholder)} - ${getStringValueOrNoInfoText(federativeUnit, placeholder)}`;
};
